<template>
<div>
  <div class="main-loading" v-if="isLoading"><adx-loading-primary /></div>
  <div v-else class="execution">
  <!-- Order Detai Header -->
    <div class="execution__header">
      <div class="execution__header__history">
        <router-link v-if="isAdmin" :to="{ name: 'allorder' }">
          <i class="adx-ic_arrow_left"></i>
          <span>All Order</span>
        </router-link>
        <router-link v-if="!isAdmin" :to="{ name: 'transactionbus' }">
          <i class="adx-ic_arrow_left"></i>
          <span>All Order</span>
        </router-link>
      </div>
      <div class="execution__header__title">
        <div class="campain-name">
          <span class="elipsis">{{ detailOrder.campaign.title }}</span>
        </div>
        <div v-if="isAdmin" class="group">
          <button class="btn-regular secondary" @click.stop="goCampaignEditor(id)">Edit</button>
          <button class="btn-regular secondary duplicate"  @click.stop="duplicateOrder">
            <span>Duplicate</span>
            <loading-secondary class="loading" v-if="isDuplicate"/> 
          </button>
          <button class="btn-regular secondary"  @click.stop="cancelOrder">Cancel</button>
          <dropdown-unlabel class="space" @selected="selected($event)" :list="menuList" labelButton=''/>
        </div>
      </div>
      <div class="execution__header__section">
        <div class="execution__header__section__detail">
          <div class="section-company">
            <span class="section-key subhead">Company Name</span>
            <span class="section-value elipsis subhead">{{ detailOrder.campaign.companyName }}</span>
          </div>
          <div class="section-start">
            <span class="section-key subhead">Start Date</span>
            <span class="section-value subhead">{{ displayDate(detailOrder.campaign.start) }}</span>
          </div>
          <div class="section-period">
            <span class="section-key subhead">Period of Campaign</span>
            <span class="section-value subhead">{{ displayPeriod(detailOrder.campaign.period)}}</span>
          </div>
          <div class="section-sales">
            <span class="section-key subhead">Sales</span>
            <span class="section-value subhead">{{ detailOrder.sales }}</span>
          </div>
        </div>
        <div class="execution__header__section__status posisition">
          <span class="section-key subhead">Campaign Status</span>
          <div v-if="isChangeStatus" class="media__loading loading">
            <loading-secondary />
          </div>
          <label-status v-else :progress="campaignStatus"/>
        </div>
      </div>
    </div>
    <!-- Order Detail Content -->
    <div class="execution__content">
      <!-- Left Content -->
      <div class="execution__content__left">
        <div class="execution__content__left__detail">
          <div class="id">
            <span class="key">ID</span>
            <span class="value">{{detailOrder.number }}</span>
          </div>
          <div class="created">
            <span class="key">Created Date</span>
            <span class="value">{{ displayDate(detailOrder.campaign.createdAt) }}</span>
          </div>
          <div class="updated">
            <span class="key">Last Updated</span>
            <span class="value">{{ displayDate(detailOrder.campaign.UpdateAt) }}</span>
          </div>
        </div>
        <div v-if="isAdmin" class="execution__content__left__component"> 
          <adx-breadcrumb-progress-status :isActive='breadcrumState' :items="breadcrumStatus" class="size"/>
          <div v-if="isChangeProgress && isAdmin" class="media__loading loading">
            <loading-secondary />
          </div>
          <dropdown-status v-if="isAdmin && !isChangeProgress" @selected="selectedProgress" :list="listStatus" labelButton="Status" :display="statusProgress" class="dropdown"/>
        </div>
        <div v-if="!isAdmin" class="execution__content__left__user"> 
          <adx-breadcrumb-progress-status :isActive='breadcrumState' :items="breadcrumStatus"/>
          <div>
            <div><label>PROGRESS</label></div>
            <div><label-status v-if="!isAdmin" :progress="statusProgress"/></div>
          </div>
        </div>
        <div class="execution__content__left__message">
          <ul class="execution__content__left__message__title__section">
            <router-link tag="li" :to="{ name: 'discussion', params: { id: this.id }}">Discussion</router-link>
            <router-link tag="li" :to="{ name: 'creativefile', params: { id: this.id }}">Creative File </router-link>
            <router-link tag="li" :to="{ name: 'mockup', params: { id: this.id } }">Mockup <badge v-if="newMockup" class="badge"/> </router-link>
            <router-link tag="li" :to="{ name: 'bast' , params: { id: this.id }}">BAST  <badge v-if="newBast" class="badge"/> </router-link>
          </ul>
          <router-view />
        </div>
        <div>
        </div>
        <!-- Discussion  -->
        <div v-if="discussionData.length > 0" class="execution__content__left__discussion">
          <div v-if="isReply">
            <loading-secondary />
          </div>
          <div v-else>
            <adx-discussions :list="discussionData" @submitComment="submit" @goToBast="bast" @goToMockup="mockup" />
          </div>
        </div>
      </div>
    <!-- Right Content -->
      <div class="execution__content__right">
        <div v-if="!isAdmin" class="execution__content__right__paymentstatus">
          <div class="execution__content__right__paymentstatus__wrapper" >
            <h1>Payment</h1>
            <div class="execution__content__right__paymentstatus__wrapper__layout">
              <div class="left-contact">
                <label-status :progress="orderPayment"/>
                <span class="span">Due Date</span>
              </div>
              <div class="right-contact">
                <span v-if="dueDate" class="span">{{ displayDate(dueDate)}}</span>
                <span v-else class="span"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAdmin"  class="execution__content__right__contact">
          <div class="execution__content__right__contact__wrapper" >
            <h1>Contact Information</h1>
            <div class="execution__content__right__contact__wrapper__layout">
              <div class="left-contact">
                <span>Contact Person</span>
                <span>Phone Number</span>
              </div>
              <div class="right-contact">
                <span >{{ detailOrder.campaign.contactPerson }}</span>
                <span>{{ detailOrder.campaign.phoneNumber }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="execution__content__right__orderSummary">
          <div class="execution__content__right__orderSummary__wrapper" >
            <h1>Order Summary</h1>
            <div v-for="(order, index) in orders" :key="index">
              <div class="execution__content__right__orderSummary__wrapper__layout">
                <div class="left-contact">
                  <span v-if="order.bus.route" class="route">{{ order.bus.route.title }}</span>
                  <span v-else class="route"> - </span>
                  <span v-if="!isLoadingeneric" class="detail"> {{ order.bus.generics.title }} - {{ order.count }}</span>
                  <span v-else class="route"><loading-secondary /></span>
                </div>
                <div class="right-contact">
                  <span v-if="!isLoadingeneric" >{{ calculatePrice(order.bus.generics.price, order.count ) | formatMoney}}</span>
                  <span v-else ><loading-secondary /></span>
                </div>
              </div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
            </div>
            <div class="execution__content__right__orderSummary__wrapper__layout">
              <div class="left-contact">
                <span class="price">Subtotal Price</span>
                <span class="price">Discount</span>
                <span class="price">PPN 10%</span>
                <span class="price">Total Price</span>
                <span v-if="isApplyDisc"> <loading-secondary/></span>
                <span v-else class="total">{{ allPrice | formatMoney }}</span>
              </div>
              <div class="right-contact">
                <span v-if="detailOrder.campaign.totalPrice" class="price">{{  getSubPrice(campaignPrice) | formatMoney }}</span>
                <span v-else class="price">{{ 0 | formatMoney }}</span>
                <span v-if="isApplyDisc" class="price"><loading-secondary/></span>
                <span v-else-if="discountAmountInput && !isApplyDisc" class="price">- {{discountAmountInput | formatMoney }}</span>
                <span v-else-if="percentDiscInput && !isApplyDisc" class="price">- {{ percentDiscInput}} % </span>
                <span v-else class="price"> {{ 0| formatMoney }}</span>
                <span v-if="isApplyDisc" class="price"><loading-secondary/></span>
                <span v-else class="price">{{ getPPN(campaignPrice) | formatMoney }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAdmin" class="execution__content__right__discount size">
          <div class="execution__content__right__discount__wrapper" >
            <h1>Discount</h1>
          </div>
          <div class="input-form">
            <adx-input class="input" :label="`Percentage`" :value.sync="percentDiscInput" :icon="`percent`" :validationMethod="`onChange`"
              :validation="['Numeric']" :error.sync="errors.percentDiscInput" :ref="dataRef.percentDiscInput"/>
            <adx-input class="input" :label="`Amount`" :value.sync="discountAmountInput" :validationMethod="`onChange`"
              :validation="['Numeric']" :error.sync="errors.discountAmountInput" :ref="dataRef.discountAmountInput"/>
          </div>
            <button class="btn-regular secondary btn" @click="applyDiscount()"  :disabled="isButtonDisable" >Apply</button>
        </div>
        <div v-if="isAdmin"  class="execution__content__right__payment">
          <div class="execution__content__right__payment__wrapper" >
            <h1>Payment</h1>
          </div>
          <div class="input-form">
            <div v-if="isChangePayment" class="media__loading loading">
              <loading-secondary />
            </div>
            <dropdown-status  v-else class="input" @selected="selectedPayment" :list="paymentList" labelButton="PAYMENT" :display="paymentStatus" :type="`input`"/>
            <div v-if="isSaveDueDate" class="loading-date">
              <loading-secondary />
            </div>
            <div v-else :class="['calendar']">
              <label v-if="dueDate" class="small-font">Due Date</label>
              <v-date-picker 
                v-model="dueDate"
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                :attributes='attributes'
                @input="saveDueDate"
                class='date-input'>
                <input
                  class="calendar-start"
                  placeholder="Due Date"
                  slot-scope='{ inputValue, updateValue }'
                  :value='inputValue'
                  :ref="'inputValue'"
                  type='text' 
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- Modal -->
    <modal v-if="isDelete"  :noTitle="true" @modal-close="closetoggleModal(1)" :type="'small'">
      <div class="execution__mockup-modal" slot="content">
          <h2 class="medium-title">Are You Sure?</h2>
            <div class="label">
              <span>You are going to delete this order and you won’t able to revert this</span>
            </div>
          <div class="execution__mockup-modal__buttons" >
            <button class="btn-large primary resend" @click.stop="deleteOrder">
                Delete
              <adx-loading-2 v-if="isDeleteOrder" />
              </button>
            <button class="btn-large primary cancel btn-white" @click="closetoggleModal(1)">Cancel</button>
          </div>
      </div>
    </modal>
    <modal v-if="isCancel" :noTitle="true" @modal-close="closetoggleModal(2)" :type="'small'">
      <div class="execution__mockup-modal" slot="content">
          <h2 class="medium-title">Reason for Cancellation</h2>
            <div class="label">
              <span>Please tell us the reason for cancellations.</span>
            </div>
            <div class="label">
              <adx-input :label="`Leave a message`" :value.sync="cancelMessage" :validation="['NotEmpty']" />
            </div>
        <div class="execution__mockup-modal__buttons" >
          <button class="btn-large primary resend" @click.stop="sendReason">
            Submit
            <adx-loading-2 v-if="isCancelOrder" />
          </button>
        </div>
      </div>
    </modal>
  </div>
</div>
</template>

<script>
import lib from '@/lib/util'
import Media from 'vue-media'
import file from '@/components/File'
import Modal from '@/components/Modal'
import Badge from '@/components/Badge'
import Input from '@/components/Form/Input'
import Pagination from '@/components/Pagination'
import LabelStatus from '@/components/StatusLabel'
import Discussions from '@/components/Discussions'
import Loading from '@/components/Loading/Primary'
import LoadingPrimary from '@/components/Loading/Primary'
import GallerySlideShow from '@/components/GallerySlideShow'
import LoadingSecondary from '@/components/Loading/Secondary'
import SelectDropdown from '@/components/Form/SelectDropdown'
import LoadingWhite from '@/components/Loading/Secondary-white';
import DropdownStatus from '@/components/Dropdown/StatusDropdown'
import ProgressStatus from '@/components/Breadcrumb/ProgressStatus'
import DropdownUnlabel from '@/components/Dropdown/UnlabelDropdown'


import * as validationLib from '@/lib/validation/'
import triggerValidation from '@/lib/triggerValidation'
import { formatShortDateTime, formatShortDate} from '@/lib/util'
import { parseErrorGql } from '@/lib/error'
import moment from 'moment'
import calendar from 'v-calendar'
import { mapGetters } from 'vuex';
import { isNull } from 'util';
import Vue from 'vue'

const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-',
  components: {
     DropdownStatus,
     DropdownUnlabel,
     LabelStatus,
    'badge': Badge,
    'modal': Modal,
    'media': Media,
    'adx-file': file,
    'adx-input': Input,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'loading-secondary': LoadingSecondary,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-2': LoadingWhite,
    'adx-selectdropdown': SelectDropdown,
    'adx-discussions': Discussions,
    'adx-gallery-slideshow': GallerySlideShow,
    'adx-breadcrumb-progress-status': ProgressStatus,
  },
  props: {

  },
  data() {
    return {
      isDelete: false,
      newMockup: false,
      isCancel: false,
      isReply: false,
      isDuplicate: false,
      isLoading: false,
      isLoadingeneric: false,
      isChangeProgress: false,
      isChangePayment: false,
      subTotalPrice: null,
      isSaveDueDate: false,
      isChangeStatus: false,
      isApplyDisc: false,
      isDiscussion: true,
      isCancelOrder: false,
      isDeleteOrder: false,
      newBast: false,
      id: null,
      image: [],
      totalPriceOrder: null,
      ppn: null,
      total: null,
      campaignID: null,
      paymentID: null,
      userName: null,
      statusProgress:null,
      paymentStatus: null,
      allPrice: null,
      discussionData: [],
      discussiondate: null,
      companyName: null,
      items: [],
      currentPage: 1,
      cancelMessage: null,
      campaignStatus: null,
      orderPayment: null,
      percentDiscInput: null,
      discountAmountInput: null,
      dataRef:{
        percentDiscInput: "percentDiscInput",
        discountAmountInput: "discountAmountInput"
      },
      errors:{
        percentDiscInput: null,
        discountAmountInput: null
      },
      dueDate: null,
      genericId: [],
      isAdmin: null,
      campaignPrice: null,
      paymentList:[
        {
          'id': 0,
          'label': 'PENDING',
          'value': 'pending'
        },
        {
          'id': 1,
          'label': 'PAID',
          'value': 'paid'
        },
        {
          'id': 2,
          'label': 'DOWNPAYMENT',
          'value': 'downpayment'
        },
        {
          'id': 3,
          'label': 'PARTIALLY',
          'value': 'partially'
        },
        {
          'id': 4,
          'label': 'AFTERPAY',
          'value': 'afterpay'
        },
      ],
      breadcrumStatus:[
        {
          'status': false,
          'title': 'Verified',
        },
        {
          'status': false,
          'title': 'Designed',
        },
        {
          'status': false,
          'title': 'Wrapped',
        }
      ],
      breadcrumState: null,
      listStatus:[
        {
          'id': 0,
          'label': 'LEAD',
          'value': 'lead'
        },
        {
          'id': 1,
          'label': 'VERIFYING',
          'value': 'verifying'
        },
        {
          'id': 2,
          'label': 'DESIGNING',
          'value': 'designing'
        },
        {
          'id': 3,
          'label': 'DESIGN APPROVAL',
          'value': 'designapproval'
        },
        {
          'id': 4,
          'label': 'PRINTING',
          'value': 'printing'
        },
        {
          'id': 5,
          'label': 'PRINT APPROVAL',
          'value': 'printapproval'
        },
        {
          'id': 6,
          'label': 'WRAPPING',
          'value': 'wrapping'
        },
        {
          'id': 7,
          'label': 'DONE',
          'value': 'done'
        }
      ],
      menuList: [
        {
          'id': 0,
          'label': 'Print',
          'value': 'print',
        },
        {
          'id': 1,
          'label': 'Delete Order',
          'value': 'deleteorder',
        },
        {
          'id': 3,
          'label': 'Set as Dormant Order',
          'value': 'dormantorder',
        },
      ],
      detailOrder: [],
      orders: [],
      model:{
        discount: null
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
          user: 'account',
          token: 'token',
          profile: 'profile'
    }),
    isButtonDisable: function() {
      let isButtonDisable = false
      if ((this.percentDiscInput == null && this.discountAmountInput == null) || (this.percentDiscInput == '' && this.discountAmountInput == '')
          || (this.percentDiscInput <= 0 && this.discountAmountInput <= 0) || this.model.discount) {
        isButtonDisable = true
      }
      return isButtonDisable
    },
    subPrice() {
      let total = 0
      this.orders.map( el => {
        total += (el.bus.generics.price * el.count)
      })
      this.campaignPrice = total
      return total
    },
  },
  watch: {
    'discountAmountInput': function (newValue, oldValue) {
      if (newValue) {
        this.percentDiscInput = ''
        this.model.discount = null
      }
    },
    'percentDiscInput': function (newValue, oldValue) {
      if (newValue) {
        this.discountAmountInput = ''
        this.model.discount = null
      }
    },
  },
  beforeCreate() {

  },
  created() {
    this.isLoading = true
    this.busOrder()
    this.id = this.$route.params.id
  },
  beforeMount() {
    
  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    this.isAdmin = this.user.isStaff
    this.userName = this.profile.full_name
    this.$on('discussionEvent', async() => {
    })
    Vue.$broker.$on("createDiscussion", () =>{
       this.busOrder()
    })
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {
    
  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods : {
    async busOrder(){
      const  res = await  this.$apollo.query({
        query:require('@/graphql/bus/busOrderDetail.gql'),
        loadingKey:'loading',
        errorPolicy:'all',
        fetchPolicy:'network-only',
        variables:{
          id: this.$route.params.id
        }
      })
      if (res.data){
        if (res.errors){
          this.handleError(res.errors, 'campaign')
        } else{
          const { busOrder } = await res.data
          if (busOrder) {
            await this.mapData(busOrder)
            this.isLoading = false
          }
        }
        this.isLoading = false
      }
    },
    async mapData(busOrder){
      this.detailOrder = await busOrder
      if (busOrder.campaign.orderRoutes.length > 0) {
        this.orders = await busOrder.campaign.orderRoutes
      }
      this.campaignID  = await busOrder.campaign.id
      this.campaignPrice = await parseInt(busOrder.campaign.totalPrice)
      this.companyName = await busOrder.campaign.companyName

      if (busOrder.discountType == "percentage") {
        this.percentDiscInput = await busOrder.discount
        this.model.discount = await this.percentDiscInput
        this.allPrice = await this.campaignPrice - ((this.percentDiscInput/100) * await this.campaignPrice)
      } else if(busOrder.discountType == "amount") {
        this.discountAmountInput = await busOrder.discount
        this.model.discount = await this.discountAmountInput
        this.allPrice = await this.campaignPrice - this.discountAmountInput
      } else{
        this.discountAmountInput = null
        this.percentDiscInput = null
        this.allPrice = this.campaignPrice 
      }

      let today = new Date()
      this.detailOrder.payment.dueDate ? this.dueDate = new Date(this.detailOrder.payment.dueDate) : this.dueDate = today
    
      //progress status and payment progress
      let statusDisplay   = this.getStatusDisplay( await busOrder.status.titleDisplay)
      let paymentDisplay  = this.getPaymentData(await busOrder.payment.statusDisplay)
      this.statusProgress = { label: statusDisplay.label, value: statusDisplay.value}
      this.paymentStatus  = {label:  paymentDisplay.label, value: paymentDisplay.value}
      this.breadcrumState = statusDisplay.status

      // campaign and payment status
      let valueStatus = {
        value: await busOrder.campaign.statusDisplay.toLowerCase(), 
        label: await busOrder.campaign.statusDisplay.toUpperCase()
      }
      let valuePayment = {
        value: busOrder.payment.statusDisplay.toLowerCase(), 
        label: busOrder.payment.statusDisplay.toUpperCase()
      }
      this.campaignStatus = valueStatus
      this.orderPayment   = valuePayment
      this.paymentStatusValue = await this.detailOrder.payment.status

      //discussion 
      this.discussionData = await busOrder.discussions
      let result = []
      
      this.discussionData.map(discussions => {
        let date = new Date (discussions.createdAt)
        let replies = []
        discussions.replies.map(reply =>{
          let dateReply = new Date(reply.createdAt)
          replies.push({
            'id'      : reply.id,
            'label'   : this.userName,
            'comment' : reply.comment,
            'date'    : dateReply
          })
        } )
        result.push({
          'id'      : discussions.id,
          'comment' : discussions.comment ,
          'label'   : discussions.file_type ? discussions.file_type : this.userName ,
          'date'    : date,
          'bast'    : discussions.file_type == 'BAST uploaded' | discussions.file_type == 'bast'? busOrder.bast : [],
          'mockup'  : discussions.file_type == 'Mockup uploaded' | discussions.file_type == 'mockup'? busOrder.mockup : [],
          'replies' : replies,
          'creative_files' : discussions.file_type == 'Creative file uploaded' | discussions.file_type == 'creative_files'? busOrder.creative_files : [],
        })
      })
      this.discussionData = result

      //generic item
      let genericIdList = []
      this.orders.map(item => {
        genericIdList.push(item.bus.genericId)
      })
      this.genericId = genericIdList
      this.genericId ? await this.getGenericItem() :  this.isLoading = false
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'campaign':
              this.count++
              if (this.count<3) {
                await this.busCampaign()
              } else{
                this.showNotification()
                this.isLoading = false
              } 
              break;
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async getGenericItem(){
      this.isLoadingeneric = true
      let titleGeneric = []
      const res = await this.$apollo.query({
          query: require('@/graphql/bus/query/getGenerics.gql'),
          loadingKey: 'loading',
          errorPolicy: 'all',
          fetchPolicy: 'network-only',
          variables:{
            id: this.genericId.join(',')
          },
      })
      if(res.data){
        const { generics } = res.data
          await this.orders.forEach(function (order) {
            generics.forEach(function (generic) {
              if(generic.id == order.bus.genericId){
                order.bus.generics = generic
              }
            });
          });
        this.isLoadingeneric = false
      }
    },
    async selectedProgress(item) {
      this.isChangeProgress = true
      const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/updateStatusByOrder.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.id.toString(),
            orderStatus: {status:item.id},
          }
        }
      );
      if (result.data) {
        await this.busOrder()
        const today = moment()
        const start = moment(this.detailOrder.campaign.start)
        if(item.id == 6 || item.id == 7 ){
          this.campaignStatus = {
            label: "UPCOMING",
            value: "upcoming"
          }
        }
        if (start.isSameOrBefore(today) && (item.id == 1 || item.id == 7)) {
          const endDate = moment(this.detailOrder.campaign.end)
          if (endDate.isSameOrAfter(today)) {
            this.campaignStatus = {
              label: "ACTIVE",
              value: "active"
            }
          } else {
            this.campaignStatus = {
              label: "EXPIRED",
              value: "expired"
            }
          }
        }
        else if(item.id == 0 || item.id == 1 || item.id == 2 || item.id == 3 || item.id == 4 || item.id == 5){
          this.campaignStatus = {
            label: "VERIFYING",
            value: "verifying"
          }
        }
        this.isChangeProgress = false 
        this.saveNotification()
      } else {
        this.errorNotification()
      }
    },
    async selectedPayment(item) {
      this.isChangePayment = true
      const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/updateBusOrderPayment.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.id.toString(),
            busOrderPayment: {
              status: item.id,
              dueDate : this.dueDate
            }
          }
        }
      );
      if (result.data) {
        await this.busOrder()
        this.isChangePayment =  false
        this.saveNotification()
      } else {
        this.errorNotification()
      }
    },
    async saveDueDate() {
      this.isSaveDueDate = true
        const result = await this.$apollo.mutate({
            mutation: require('@/graphql/bus/updateBusOrderPayment.gql'),
            errorPolicy: 'all',
            variables: {
              id: this.id.toString(),
              busOrderPayment: {
                status: this.paymentStatusValue,
                dueDate : this.dueDate
              }
            }
          }
        );
        if (result.data) {
          await this.busOrder()
          this.isSaveDueDate =  false
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Change Due Date Saved',
            type: 'success'
            });
        } else {
          this.$notify({
            group: 'saved',
            title: 'Failed',
            text: 'Change Due Date Fail!',
            type: 'success'
            });
        }
    },
    async applyDiscount() {
      this.discountAmountInput ?  this.model.discount = this.discountAmountInput : this.model.discount = this.percentDiscInput
      let body = {
        'percentDiscInput': this.percentDiscInput,
        'discountAmountInput': this.discountAmountInput
      }
      let validation = triggerValidation(body, this.dataRef, this.$refs, this.errors)
      if(validation){
        this.isApplyDisc =  true
        this.endPrice()
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/updateBusOrder.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.id.toString(),
            busOrder: {
              discount :this.model.discount,
              discountType : this.discountAmountInput > 0 ? 'amount' : 'percentage'
            }
          }
        }
      );
      if (result.data) {
        await this.busOrder()
        this.isApplyDisc =  false
        this.discNotification()
      } else {
        this.errorDiscNotification()
      }
      }
    },
    async changeDormant() {
      this.isChangeStatus = true
      const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/updateBusCampaign.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.campaignID.toString(),
            campaign: {
              campaignInfo:{
              status : 6
              }
            }
          }
        }
      );
      if (result.data) {
        await this.busOrder()
        this.isChangeStatus = false
        this.saveNotification()
      } else {
        this.errorNotification()
      }
    },
    async submit(comment, item) {
      if(comment) {
        this.isReply= true
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/replyAdd.gql'),
          errorPolicy: 'all',
          variables:{
            input:{
              comment: comment,
              discussion:{
                id: parseInt(item.id)
              }
            },
          },
        });
        if (result.data) {
          await this.busOrder()
          this.replyNotification()
        } else {
          this.errorReply()
        }
        this.isReply= false
      }
    },
    async sendReason() {
      this.isCancelOrder = true
      if(this.cancelMessage) {
        const result2 = this.$apollo.mutate({
            mutation: require('@/graphql/bus/discussionAdd.gql'),
            variables:{
              input:{
                comment: this.cancelMessage,
                file_type: this.userName,
                order:{
                  id: parseInt(this.$route.params.id)
                },
              },
            },
        });
        await this.busOrder()
        this.isCancelOrder = false
        this.$router.push({ name: 'orderdetailexecution', params: { id: this.id }})
        this.isCancel = false
        if (this.cancelMessage) {
          const result = await this.$apollo.mutate({
              mutation: require('@/graphql/bus/updateBusCampaign.gql'),
              errorPolicy: 'all',
              variables: {
                id: this.campaignID.toString(),
                campaign: {
                  campaignInfo:{
                  status : 3
                  }
                }
              }
          });
          if (result.data) {
            await this.busOrder()
            this.isChangeStatus = false
            this.saveNotification()
          } else {
            this.errorNotification()
          }
        }
      } else {
        this.errorNotification()
      }
    },
    async duplicateOrder() {
      this.isDuplicate = true
      const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/duplicateBusOrder.gql'),
          errorPolicy: 'all',
          variables: {
            id: this.id.toString()
          }
        }
      );
      if (result.data) {
        await this.busOrder()
        this.isDuplicate = false
        this.duplicateNotif()
        this.$router.replace({ name: 'allorder', params: { isPushed: true } })
      } else {
        this.errorNotif()
      }
    },
    async deleteOrder() {
      this.isDeleteOrder = true
      const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/deleteBusOrder.gql'),
          errorPolicy: 'all',
          loadingKey: 'loading',
          variables: {
            id: this.id.toString()
            
          }
        }
      );
      if (result.data) {
        this.isDeleteOrder = false
        this.deleteNotif()
        this.$router.replace({ name: 'allorder', params: { isPushed: true }  })
      } else {
        this.deleteError()
      }
    },
    saveNotification() {
      this.$notify({
            group: 'saved',
            title: 'Change Status',
            text: 'Change Status Saved',
            type: 'success'
      });
    },
    errorNotification() {
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Change Status Failed!',
            type: 'warn'
      });
    },
    deleteNotif(){
      this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Order has been Delete!',
            type: 'success'
      });
    },
    deleteError(){
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Delete Order Failed!',
            type: 'warn'
      });
    },
    discNotification() {
      this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Apply Discount Success',
            type: 'success'
      });
    },
    errorDiscNotification() {
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Apply Discount Failed',
            type: 'warn'
      });
    },
    replyNotification() {
      this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Reply Submited',
            type: 'success'
      });
    },
    errorReply() {
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: ' Reply Failed!',
            type: 'warn'
      });
    },
    duplicateNotif() {
      this.$notify({
            group: 'saved',
            title: 'Sucess',
            text: 'Duplicate Sucess',
            type: 'success'
      });
    },
    errorNotif(){
      this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Duplicate Failed!',
            type: 'warn'
      });
    },
    selected(e, item) {
      if(e.value == 'print') {
        window.print();
      } else if (e.value == 'deleteorder') {
        this.isDelete = !this.isDelete
      } else if (e.value == 'dormantorder') {
        this.changeDormant()
      } 
    },
    cancelOrder() {
      this.isCancel =  !this.isCancel
    },
    getSubPrice(price){
      this.subTotalPrice = this.campaignPrice - ((this.campaignPrice * 10)/ 110)
      return this.subTotalPrice
    },
    getPPN(ppn) {
      this.ppn
      return this.subTotalPrice * 0.1
    },
    displayDate(date) {
      return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', date)}`
    },
    displayPeriod(period) {
      return period + ' Months'
    },
    calculatePrice(price, count) {
      return price * count * this.detailOrder.campaign.period
    }, 
    endPrice() {
      let total = 0
      if (this.campaignPrice && this.discountAmountInput) {
        total = this.campaignPrice - this.discountAmountInput
      } else if  (this.campaignPrice && this.percentDiscInput) {
         total = this.campaignPrice - ( this.campaignPrice * (this.percentDiscInput / 100) )
      }
      return this.allPrice = total
    },
    bast() {
      this.isDiscussion= false
      this.isCreativeFile= false
      this.isMockup= false
      this.isBast= true
    },
    mockup() {
      this.isDiscussion= false
      this.isCreativeFile= false
      this.isMockup= true
      this.isBast= false
    },
    gotoBast() {
      this.bast()
    },
    goCampaignEditor(id) {
      this.$router.push({name: 'campaignorderdetail', params: { id: this.campaignID , orderID : this.id, isOrder: true}})
    },
    openToggleModal(index) {
      if(index == 1) {
        this.isDelete = !this.isDelete
      } else if(index == 2) {
        this.isMockupModal = !this.isMockupModal
      } else if(index == 3) {
        this.isBastModal =  !this.isBastModal
      } 
    },
    closetoggleModal(index) {
      index == 1 ? this.isDelete = !this.isDelete : this.isCancel = !this.isCancel
    },
    getPaymentData(statusDisplay) {
      let payment = statusDisplay.toLowerCase()
      let res = {}
      switch(payment) {
        case `pending`:
          res = {value: 'pending', label: 'PENDING'}
          break
        case `afterpay`:
          res = {value: 'afterpay', label: 'AFTERPAY'}
          break
        case `paid`:
          res = {value: 'paid', label: 'PAID'}
          break
        case `downpayment`:
          res = {value: 'downpayment', label: 'DOWNPAYMENT'}
          break
        case `partially`:
          res = {value: 'partially', label: 'PARTIALLY'}
          break
      }
      return res
    },
    getStatusDisplay(status) {
      let state = status.toLowerCase()
      let res = []
      switch(state) {
        case `lead`:
          res = { id: 0, value: 'lead', label: 'LEAD', status: ''}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: ''}
          break
        case `designing`:
          res = { id: 2, value: 'designing', label: 'DESIGNING', status: 'verified'}
          break
        case `designapproval`:
          res = { id: 3, value: 'designapproval', label: 'DESIGN APPROVAL', status: 'verified'}
          break
        case `printing`:
          res = { id: 4, value: 'printing', label: 'PRINTING', status: 'verified'}
          break
        case `printapproval`:
          res = { id:5, value: 'printapproval', label: 'PRINT APPROVAL', status: 'verified'}
          break
        case `wrapping`:
          res = { id:6, value: 'wrapping', label: 'WRAPPING', status:'designed'}
          break
        case `done`:
          res = { id:7, value: 'done', label: 'DONE', status:'wrapped'}
      }
      return res
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
    .file-name {
      span {
        font-size: 12px;
        width: 100px;
        height: 16px;
        font-size: 12px;
        margin-top: 2px;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      i{
        margin-top: 3px;
        font-size: 16px;
        margin-left: 6px;
        color: #999999;
        cursor: pointer;
      }
    }

    .execution{
      &__header{
        &__title{
          .group{
            .dropdownUnlabel{
              &__menu{
                left: -145px;
              }
            }
          }
        }
      }
      &__content{
        &__left{
          &__component{
            .dropdown-status{
              button{
                height: 40px;
                i{
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    } 
</style>

<style lang="scss">
  @media print {
    body {
      width: auto;
      margin: none;
    }

    footer {
      display: none !important;
    }

    .container  {
      div{
        .execution {
          max-width: 1080px;
          &__header{
            padding: 8px 621px 8px 118px;

            &__history{
              display: flex;
              color: #ff2d55;
              margin-bottom: 8px;

              i{
                align-self: center;
                margin-right: 2px;
                color: #ff2d55;
                cursor: pointer;
              }

              span {
                width: 141px;
                height: 16px;
                font-size: 15px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.07;
                letter-spacing: normal;
                color: #ff2d55;
              }
            }


            &__title{
              display: flex;
              justify-content: space-between;
              
              .campain-name{

                  .elipsis{
                    display: inline-block;
                    max-width: 400px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                span{
                  font-size: 20px;
                  color: #262626;
                }
              }


              .space {
                margin-left: 4px;
              }
              
              .group {
                margin-right: 10px;
                display: flex;
                transform: scale(0.7);

                .dropdownUnlabel{
                  &__menu{
                    display : none;
                  }
                }
              }
            }

            &__section{
              display: flex;
              flex-direction: row;
              margin-top: 16px;

              &__detail{
                display: flex;
                flex-direction: row;

                .section-company, .section-start, .section-period, .section-sales{
                  width: 117px;
                  height: 16px;

                }

                .section-company{
                  .section-key, .section-value{
                    display: flex;
                    flex-direction: column;
                  }
                }

                .section-start{
                  .section-key, .section-value{
                    display: flex;
                    flex-direction: column;
                  }
                }

                .section-period{
                  .section-key, .section-value{
                    display: flex;
                    flex-direction: column;
                  }
                }

                .section-sales{
                  .section-key, .section-value{
                    display: flex;
                    flex-direction: column;
                  }
                }

                .section-key {
                  text-transform: uppercase;
                  font-size: 10px;
                  font-weight: bold;
                  color: #999999;
                  margin-bottom: 8px;
                }
                
                .section-value {
                  font-size: 13px;
                  color: #242424;
                }
              }

              &__status{
                margin-left: -32px;
                display: flex;
                flex-direction: column;

                .section-key {
                  text-transform: uppercase;
                  font-size: 10px;
                  font-weight: bold;
                  color: #999999;
                  margin-bottom: 8px;
                }

              
              }
            } 
          }
          
          &__content{
            display: flex;
            margin: 0px;
            padding: 0px 220px 0px 55px;
            max-width: 1080px;

            &__left{
              margin-right: 22px;
              width: 1300px;

                  
              &__detail{
                display: flex;
                flex-direction: row; 
                margin-bottom: 0px;

                .id, .created, .updated{
                  display: flex;
                  flex-direction: row; 
                  width: 132px;
                  height: 24px;;
                }

                .key{
                  font-size: 10px;
                  color: #999999;
                  margin-right: 3px;
                }

                .value{
                  font-size: 10px;
                  color: #242424;
                }

              }

              &__component{
                display:flex;
                justify-content: space-between;
                margin-bottom: 16px;

                .dropdown-status{
                  button{
                    margin-right: -36px;
                  }
                }

                .size{
                  transform: scale(0.55);
                  margin-left: -120px;
                }

                .dropdown{
                  transform: scale(0.55);
                  margin-left: -120px;
                }

                .loading{
                  margin: 5px 20px;
                }
              }

              &__user{
                display:flex;
                margin-bottom: 16px;

                div{
                  label{
                    color: #999999;
                    font-size: 14px;
                    font-weight: bold;
                  }
                }
              }

              &__message {
                width: auto;
                height: auto;
                border-radius: 8px;
                background-color: #fafafa;
                padding: 16px;

                &__title {
                  margin-bottom: 16px;
                  display: flex;
            
                  &__section {
                    display: flex;
            
                    li {
                      display: flex;
                      margin-right: 24px;
                      cursor: pointer;
                      height: 24px;
                      align-items: center;
                      color: #999999;
                      font-size: 13px;
            
                      &:last-child {
                        margin-right: 0;
                      }

                      .badge{
                        position: relative;
                        top: -56%;
                        min-width: 8px;
                        height: 9px;
                      }
                    }
                  }
                }   

                .discussion{

                  textarea{
                    max-height: 60px;
                  }
                  button{
                    margin-top: 8px;
                    margin-left: 84.5%;
                    max-width: 100%;
                  }
              }

              }
              .mockup{
                .file-section{

                  .upload-box{
                    transform: scale(0.65);
                    margin-left: -94px;
                    margin-top: -2px;

                    span{
                      display: none;
                    }
                  }
                  button{
                      transform: scale(0.6);
                      margin-left: 269px;
                      margin-top: 0px;
                    }
                }
              }
              .bast{
                .file-section{
                  .upload-box{
                    transform: scale(0.65);
                    margin-left: -94px;
                    margin-top: -2px;

                    span{
                      display: none;
                    }
                  }
                  div{
                    button{
                      transform: scale(0.6);
                      margin-left: 280px;
                      margin-top: -12px;
                    }
                  }
                }
              }
              .creativefile{
                .file-section{
                  .creative{
                    margin-left: 80%;
                    margin-top: 8px;
                  }
                }
              }
              &__discussion {
                margin-top: 16px;

                .discussion{
                  .wrapper{
                    .wrapper-content{
                      .parent_top{
                        span{
                          font-size: 12px;
                        }
                      }

                      .parent_bottom{
                        .child{
                          .comment{
                            .child_top{
                              span{
                                font-size: 12px;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            &__right{

              &__contact ,  &__paymentstatus{
                width: 252px;
                height: 95px;
                border-radius: 8px;
                background-color: #fafafa;

                margin-bottom: 16px;

                &__wrapper{
                  padding: 16px;

                  h1{
                    color: #999999;
                    font-size: 11px
                  }

                  &__layout{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 16px;

                    .left-contact{
                      display: flex;
                      flex-direction: column;

                      .span{
                        margin-top: 8px;
                      }

                      .label{
                        margin-top: -6px;
                      }

                      span{
                        margin-bottom: 8px;
                        font-size: 11px;

                      }
                    }

                    .right-contact{
                      display: flex;
                      flex-direction: column;

                      .span{
                        margin-top: 28px;
                      }

                      span{
                        margin-bottom: 8px;
                        font-size: 11px;
                        font-weight: bold;
                      }
                    }
                  }
                }
              }

              &__orderSummary{
                width: 252px;
                height: max-content;
                border-radius: 8px;
                background-color: #fafafa;
                margin-top: 16px;

                h1{
                  color: #999999;
                  font-size: 11px
                }

                &__wrapper{
                  padding: 16px;

                  .line-wrapper {
                    padding: 4px 0 8px;

                    .line {
                      height: 1px;
                      // background-color: $pale-grey;
                      border: none;
                    }
                  }

                  &__layout{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 16px;

                    .left-contact{
                      display: flex;
                      flex-direction: column;

                      span{
                        margin-bottom: 4px;
                      }

                      .route {
                        font-size: 11px;
                        font-weight: bold;
                      }

                      .price{
                        font-size: 11px;
                        font-weight: bold;
                        margin-bottom: 16px;
                      }

                      .total{
                        font-size: 15px;
                        font-weight: bold;
                        color: #ff2d55;
                      }

                      .detail{
                        font-size: 11px;
                        color: #999999;
                      }
                    }

                    .right-contact{
                      display: flex;
                      flex-direction: column;
                      max-width: 60%;

                      .loading{
                        margin-bottom: 18px;
                      }

                      span{
                        margin-bottom: 8px;
                        font-size: 10px;
                        font-weight: bold;
                        color: #ff2d55;
                      }

                      .price{
                        margin-bottom: 16px;
                        text-align: right;
                      }
                    }
                  }
                }

              }

              &__discount{
                transform: scale(0.85);
                margin: -5px -20px;

                h1{
                  color: #999999;
                  font-size: 12px
                }

                .input-form{
                  padding: 0px 16px 0px 16px;

                  .dropdown {
                    margin-left: 16px;
                    &:last-child {
                      margin-right: 0;
                    }
                
                    background-color: white;
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 28px 16px 12px 16px;
                    min-height: 64px;
                    border-radius: 4px;
                    width: calc(30% - 8px);
                
                    label {
                      position: absolute;
                      top: 12px;
                      left: 16px;
                    }
                
                    i{
                      display: flex;
                    }
                
                    &.warning {
                      margin-top: 0;
                    }
                  }

                  .input{
                    margin-bottom: 8px;
                  }
                }

                .btn{
                  margin-left: 181px;
                }

                  &__wrapper{
                  padding: 16px;
                }

              }

              &__payment{
                transform: scale(.85);
                margin: -20px -20px;

            
                h1{
                  color: #999999;
                  font-size: 15px
                }

                .input-form{
                  padding: 0px 16px 0px 16px;

                  .loading{
                    margin-bottom: 24px;
                    margin-top: 8px;
                  }

                  .input{
                    margin-bottom: 8px;
                  }

                  .calendar {
                    background-color: white;
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 28px 16px 12px 16px;
                    min-height: 64px;
                    border: 1px solid #E5E5EA;
                    border-radius: 4px;
            
                    label {
                      position: absolute;
                      top: 12px;
                      left: 16px;
                    }
            
                    .date-input {
                      position: unset !important;
                      width: 100%;
            
                      input {
                        background-color: transparent;
                        color: transparent;
                        border: none;
                        cursor: pointer;
                        font-size: 15px;
                      }
                    }
                  }
                }

                &__wrapper{
                  padding: 16px;
              }
              }
            }
          } 
        }
      }
    }
  }

  @page {
    size: A4 portrait;
    counter-increment: page;
  }
</style>